// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__eGPz_","fileBtn":"File_fileBtn__2vu81","closeBtn":"File_closeBtn__1UONd","fileSelected":"File_fileSelected__BeuxN","disabled":"File_disabled__3CI5s"};